import {
  invoiceFoot,
  invoiceHead,
  InvoiceTemplate,
} from "src/components/email/InvoiceTemplate";

const data = {
  balance: "0.00",
  balanceColor: "green",
  invoiceDate: "Mon, March 23, 1985",
  last4: "4242",
  logo: "https://api.captyn.com/s3/16ce86e8-a4d9-400f-b1ba-5753ec93effd",
  numberOfItems: "2 items",
  organizationAddress1: "1234 Street Ave.",
  organizationCity: "Raleigh",
  organizationEmail: "naples@captyn.com",
  organizationPhone: "(919) 122-3301",
  organizationState: "NC",
  organizationTitle: "Naples Swim",
  organizationUrl: "https://captyn.com",
  organizationZip: "91919",
  totalBillable: "165.50",
  totalCharges: "175.50",
  totalCoupons: "5.00",
  totalCredits: "5.00",
  totalDiscounts: "17.00",
  totalPaid: "165.50",
  totalRefunds: "15.50",
  type: "Invoice",
  userEmail: "frank@window.com",
  userName: "Jimmy Johnson",
};

export default function InvoiceTest() {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: invoiceHead }} />
      <InvoiceTemplate {...data} />
      <div dangerouslySetInnerHTML={{ __html: invoiceFoot }} />
    </>
  );
}
